export const PathNamekRoutes = {
  EMPLOYEE: "asociados",
  PROGRAMS: "programs",
  PAYMENTSETTLEMENT: "paymentSettlement",
  RENDITION: "rendition",
  CATEGORIES: "categories",
  CONFIGURATION: "configuration",

  MACROGENERATORS: "macroGenerators",
  COLLECTIONS: "collections",

  PRESENTEEISM: {
    EMPLOYEES: "empleados",
    ASSOCIATES: "asociados",
    RUTAS: "rutas",
    REPORT: "reporte",
    SEALBATCHES: "generador-precintos",
  },

  WEIGHING: {
    REVIEW: "revision-manual",
    PRODUCTIVITY: "reporte-productividad",
    DETAILED_PRODUCTIVITY: "reporte-detallado-productividad",
  },

  CONFIG: {
    MATERIALS: "materiales",
    ASSIGN_MATERIALS: "asignacion-materiales",
  },
  POWERBI: {
    DASHBOARD: "dashboard",
  },

  UNAUTHORIZED: "unauthorized",
  LOGOUT: "logout",
  LOGIN: "login",
  WELCOME: "",
};
